<template>
  <div class="content-box">
    <router-link :to="link">
    <div class="content-header">
      <div class="content-title">
        {{title}}
      </div>
    </div>
    <div class="content-image">
      <img :src="require('@/assets/top/'+imgSrc)">
    </div>
    <div class="text">
      {{text}}
    </div>
    </router-link>
  </div>
</template>

<script>
import users from '@/assets/top/content-list.json'

export default {
  name: 'contentBox',
  props: {
    c_id: String,
    link: String
  },
  data () {
    return {
      title: users[this.c_id]['title'],
      imgSrc: users[this.c_id]['imgSrc'],
      text: users[this.c_id]['text']
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  .content-box{
    height: 100%;
    text-align: left;

    a, a:visited{
      text-decoration: none;

      .content-header{
        .content-title{
          color: #3B3B3B;
          transition: color .4s ease;
          -webkit-transition: color .4s ease;
        }
      }
      .text{
        color: #3B3B3B;
        transition: color .4s ease;
        -webkit-transition: color .4s ease;
      }
    }
    a:hover{
      .content-header{
        .content-title{
          text-decoration: none;
          color: #D0AF1F;
        }
      }
      .text{
        text-decoration: underline;
        color: #D0AF1F;
      }
    }
  }
  .content-image{
    height: 84%;
    position: relative;
    top: -0.8vw;
    z-index: 7;

    img{
      width: 100%;
      height: auto;
    }

    @media (max-width: 1000px) {
      top: -13px;
    }
    @media (max-width: 550px) {
      top: -10px;
    }
  }
  .content-header{
    width: 100%;
    position: relative;
    z-index: 8;

    .content-title{
      color: #3B3B3B;
      font-size: 3.1vw;
      font-weight: bold;
    }
    .content-more{
      display: none;
    }

    @media (max-width: 1000px) {
      .content-title{
        font-size: 65px;
        width: 80%;
      }
    }

    @media (max-width: 550px) {
      display: flex;
      justify-content: space-between;
      .content-title{
        font-size: 40px;
      }

      .content-more{
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40px;
        right: 0px;
        color: #3B3B3B;
      }
    }
  }
  .text{
    color: #000000;
    font-size: 1vw;
    font-weight: 550;
    line-height: 2vw;
    position: relative;
    top: -1.8vw;
    z-index: 5;
    text-align: justify;
    @media (max-width: 550px) {
      display: none;
    }
  }

</style>
